import axios from 'axios';
import { INewsletterFormData } from '../../components/sections/Newsletter/interfaces';
import { AgreementValue } from './hubspot';

export const submit_hubspot_newsletter = async ({
  firstname,
  email,
  agreement,
}: INewsletterFormData) => {
  const portalId = '9219940';
  const formGuid = '320c7505-c5df-43f6-9093-36ad37c0fd5d';
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const response = await axios.post(
    `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`,
    {
      portalId,
      formGuid,
      fields: [
        {
          name: 'firstname',
          value: firstname,
        },
        {
          name: 'email',
          value: email,
        },
        {
          name: 'agreement',
          value:
            AgreementValue[agreement as unknown as keyof typeof AgreementValue],
        },
      ],
      context: { pageUri: 'www.qodeca.com' },
    },
    config
  );

  return response;
};
